import { Routes } from '@angular/router';

import { requireUserSetupGuard } from './guards';

export const ROUTES: Routes = [
    {
        path: '',
        loadChildren: () => import('./authentication-layout/authentication-layout.routes').then((r) => r.routes),
        canActivate: [requireUserSetupGuard],
        canActivateChild: [requireUserSetupGuard],
    },

    {
        path: '',
        loadChildren: () => import('./system/system.routes').then((r) => r.routes),
        data: { preload: true },
    },

    {
        path: '**',
        redirectTo: '',
    },
];
